<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Analytics</h5>
                  <h2 class=" card-title"><i class="fas fa-chess-rook fa-lg"></i>&nbsp;&nbsp;&nbsp; Factor Analysis</h2>
                </div>
                <div class=" col-sm-6">
                  <div class=" btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='styleBox'}"
                           (click)="selectedPage='styleBox'">Style Box</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='synthesis'}"
                           (click)="selectedPage='synthesis';selectedTabTab='Exposure'">Synthesis</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage=='peerChart'}"
                           (click)="selectedPage='peerChart';selectedTab='deconcentration'">Peer Chart</label>
                  </div>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngIf="selectedPage=='styleBox'">

                <br>
                <!-- Style Box chart -->
                <app-style-box *ngIf="styleBoxData"
                                      [catNames]="['Weights','Risk']"
                                      [catFields]="['factor_deconcentration','factor_diversification']"
                                      [series]="[
                                        {label: 'original',   values: styleBoxData.original},
                                        {label: 'investable', values: styleBoxData.investable},
                                        {label: 'protected',  values: styleBoxData.protected}
                                      ]">
                </app-style-box>
                <!-- Style Box chart -->

              </div>
              <div *ngIf="selectedPage=='synthesis'">
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onTabChangeTab($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab *ngIf="currentFA && currentFA.exposure" label="Exposure"></mat-tab>
                  <mat-tab *ngIf="currentFA && currentFA.sensitivity" label="Sensitivity"></mat-tab>
                  <!-- <mat-tab *ngIf="currentFA && currentFA.stability" label="Stability"></mat-tab> -->
                  <mat-tab *ngIf="currentFA && currentFA.contribution" label="Contributions"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Exposure bar chart -->
                <app-basic-bar-chart *ngIf="selectedTabTab=='Exposure' && currentFA"
                                     [catNames]="['Size','Value','Momentum','Volatility','High Yield','Quality']"
                                     [catFields]="['size','value','momentum','volatility','high_yield','quality']"
                                     [series]="[
                                         {label: 'inception', values: currentFA.exposure.inception},
                                         {label: '10y',       values: currentFA.exposure['10y']},
                                         {label: '5y',        values: currentFA.exposure['5y']},
                                         {label: '3y',        values: currentFA.exposure['3y']}
                                       ]">
                </app-basic-bar-chart>
                <!-- Exposure bar chart -->

                <!-- Sensitivity bar chart -->
                <app-basic-bar-chart *ngIf="selectedTabTab=='Sensitivity' && currentFA"
                                     [catNames]="['Size','Value','Momentum','Volatility','High Yield','Quality']"
                                     [catFields]="['size','value','momentum','volatility','high_yield','quality']"
                                     [series]="[
                                         {label: 'mean',       values: currentFA.sensitivity.mean},
                                         {label: 'rmse',       values: currentFA.sensitivity['rmse']},
                                         {label: 'best_5pct',  values: currentFA.sensitivity['best_5pct']},
                                         {label: 'worst_5pct', values: currentFA.sensitivity['worst_5pct']}
                                       ]" percent>
                </app-basic-bar-chart>
                <!-- Sensitivity bar chart -->

                <!-- Stability bar chart --
                <app-basic-bar-chart *ngIf="selectedTabTab=='Stability' && currentFA"
                                     [catNames]="['Alpha','Factor Beta','Factor Intensity']"
                                     [catFields]="['alpha','factor_beta','factor_intensity']"
                                     [series]="[
                                         {label: 'stability', values: currentFA.stability}
                                       ]" [showLegend]="false">
                </app-basic-bar-chart>
                !-- Stability bar chart -->

                <!-- Contribution bar chart -->
                <app-basic-bar-chart *ngIf="selectedTabTab=='Contributions' && currentFA"
                                     [catNames]="['Size','Value','Momentum','Volatility','High Yield','Quality']"
                                     [catFields]="['size','value','momentum','volatility','high_yield','quality']"
                                     [series]="[
                                         {label: 'exposure',  values: currentFA.contribution.coefficient},
                                         {label: 'risk_premium', values: currentFA.contribution['risk_premium']},
                                         {label: 'return_contribution', values: currentFA.contribution['return_contribution']}
                                       ]" percent>
                </app-basic-bar-chart>
                <!-- Contribution bar chart -->
              </div>
              <div *ngIf="selectedPage=='peerChart'">
                <!--Peers Chart-->
                <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
                  <mat-tab label="Weights"></mat-tab>
                  <mat-tab label="Risk"></mat-tab>
                </mat-tab-group>
                <br><br>
                <app-peers-widget-chart *ngIf="selectedTab=='deconcentration'" [peerProducts]="[]" target="deconcentration"
                                        [originalPA]="currentOriginalPA" [investablePA]="currentInvestablePA" [protectedPA]="currentProtectedPA"
                                        (selectedPeerChange)="onSelectedPeerChange($event)"
                                        [selectedType]="selectedType" [selectedIndex]="selectedIndex"></app-peers-widget-chart>
                <app-peers-widget-chart *ngIf="selectedTab=='diversification'" [peerProducts]="[]" target="diversification"
                                        [originalPA]="currentOriginalPA" [investablePA]="currentInvestablePA" [protectedPA]="currentProtectedPA"
                                        (selectedPeerChange)="onSelectedPeerChange($event)"
                                        [selectedType]="selectedType" [selectedIndex]="selectedIndex"></app-peers-widget-chart>
                <!--Peers Chart-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedPage=='synthesis'" class=" content">
        <br>
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-center">
                    <h2 class=" card-title"><span *ngIf="selectedPage=='synthesis'">{{ selectedTabTab }}</span></h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">
                <div *ngIf="selectedPage=='synthesis'">
                  <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                  <!-- Exposure table -->
                  <table id="tableToExport" *ngIf="selectedTabTab=='Exposure' && currentFA && currentFA.exposure" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['3 Years','5 Years','10 Years','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="currentFA.exposure.alpha">
                      <th style="color: grey" scope="row">Alpha</th>
                      <td style="color: grey" *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.alpha[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.market_exposure">
                      <th style="color: grey" scope="row">Market Exposure</th>
                      <td style="color: grey" *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.market_exposure[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.size">
                      <th scope="row">Size</th>
                      <td *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.size[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.value">
                      <th scope="row">Value</th>
                      <td *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.value[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.momentum">
                      <th scope="row">Momentum</th>
                      <td *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.momentum[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.volatility">
                      <th scope="row">Volatility</th>
                      <td *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.volatility[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.high_yield">
                      <th scope="row">High Yield</th>
                      <td *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.high_yield[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.quality">
                      <th scope="row">Quality</th>
                      <td *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.quality[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.factor_intensity">
                      <th scope="row">Factor Intensity</th>
                      <td *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.factor_intensity[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.exposure.r_squared">
                      <th style="color: grey" scope="row">R-Squared</th>
                      <td style="color: grey" *ngFor="let cat of ['3y','5y','10y','inception']">{{ currentFA.exposure.r_squared[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Exposure table -->

                  <!-- Sensitivity table -->
                  <table id="tableToExport" *ngIf="selectedTabTab=='Sensitivity' && currentFA && currentFA.sensitivity" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['Mean','Std Error','Best 5%','Worst 5%']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="currentFA.sensitivity.alpha">
                      <th style="color: grey" scope="row">Alpha</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.alpha[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.sensitivity.size">
                      <th scope="row">Size</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.size[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.sensitivity.value">
                      <th scope="row">Value</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.value[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.sensitivity.momentum">
                      <th scope="row">Momentum</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.momentum[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.sensitivity.volatility">
                      <th scope="row">Volatility</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.sensitivity.high_yield">
                      <th scope="row">High Yield</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.high_yield[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.sensitivity.quality">
                      <th scope="row">Quality</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.quality[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.sensitivity.factor_intensity">
                      <th scope="row">Factor Intensity</th>
                      <td *ngFor="let cat of ['mean','rmse','best_5pct','worst_5pct']">{{ currentFA.sensitivity.factor_intensity[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Sensitivity table -->

                  <!-- Stability table --
                  <table id="tableToExport" *ngIf="selectedTabTab=='Stability' && currentFA && currentFA.stability" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['Stability']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="currentFA.stability.alpha">
                      <th scope="row">Alpha</th>
                      <td>{{ currentFA.stability.alpha | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.stability.factor_beta">
                      <th scope="row">Factor Beta</th>
                      <td>{{ currentFA.stability.factor_beta | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.stability.factor_intensity">
                      <th scope="row">Factor Intensity</th>
                      <td>{{ currentFA.stability.factor_intensity | number:'1.2-2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  !-- Stability table -->

                  <!-- Contribution table -->
                  <table id="tableToExport" *ngIf="selectedTabTab=='Contributions' && currentFA && currentFA.contribution" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['Exposure','Risk Premium','Return Contribution']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="currentFA.contribution.alpha">
                      <th style="color: grey" scope="row">Alpha</th>
                      <td style="color: grey" *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.alpha[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.market_exposure">
                      <th style="color: grey" scope="row">Market Exposure</th>
                      <td style="color: grey" *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.market_exposure[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.size">
                      <th scope="row">Size</th>
                      <td *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.size[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.value">
                      <th scope="row">Value</th>
                      <td *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.value[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.momentum">
                      <th scope="row">Momentum</th>
                      <td *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.momentum[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.volatility">
                      <th scope="row">Volatility</th>
                      <td *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.high_yield">
                      <th scope="row">High Yield</th>
                      <td *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.high_yield[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.quality">
                      <th scope="row">Quality</th>
                      <td *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.quality[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="currentFA.contribution.total">
                      <th style="color: grey" scope="row">Total</th>
                      <td style="color: grey" *ngFor="let cat of ['coefficient', 'risk_premium','return_contribution']">{{ currentFA.contribution.total[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Contribution table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
